<template>
  <el-dialog
    title=""
    :visible="showLoginModal"
    :show-close="false"
    width="800px"
    height="600px"
    class="ts-modal"
  >
    <h4 style="margin: auto; text-align: center">How can we help you today?</h4>
    <br>
    <h4 style="margin: auto; text-align: center">Please select all that apply</h4>
    <!-- <div v-for="(item, index) in items" :key="index">
        <div class="box" :xl="12" :lg="12" :md="12" :sm="12">
            <input type="radio" :id="'option-' + index" :name="'option'" class="radio-button" :value="item.value" />
            <label class="label">{{item.label}}</label>
        </div>
    </div> -->
    <br>
    <br>
    <el-row :gutter="20">
        <div v-for="(item, index) in items" :key="index">
            <el-col class="box" v-if="item.value != 7" :span="11" >
                <input type="radio" :id="'option-' + index" :name="'option'" class="radio-button" :value="item.label" v-model="LoginReason" style="cursor: pointer" />
                <label class="label">{{item.label}}</label>
            </el-col>
            <el-col class="box" v-else offset="6" span="11">
                <input type="radio" :id="'option-' + index" :name="'option'" class="radio-button" :value="item.label" v-model="LoginReason" style="cursor: pointer" />
                <label class="label">{{item.label}}</label>
            </el-col>
        </div>
    </el-row><br>
    <el-row>
        <el-col :span="24" style="text-align: center">
            <el-button class="ts-btn ts-btn-small ts-btn-secondary" style="width:200px; margin:auto;" @click="submitLogin()" >
                Submit
            </el-button>
        </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  name: "LoginModal",
  props: {
    showLoginModal: {
      type: Boolean,
      default: () => (false)
    }
  },
  data() {
    return {
      LoginReason: null,
      items: [
        {label: "Job Search", value: 1},
        {label: "Resume Builder", value: 2},
        {label: "Eligibility for Services", value: 3},
        {label: "Skills Passport", value: 4},
        {label: "Schedule Meeting", value: 5},
        {label: "Register for Workshops", value: 6},
        {label: "Resources", value: 7},
      ] // Replace this with your actual data
    };
  },
  created() {},
  mounted() {},
  computed: {
    currentUser() {
      return this.$store.state.account;
    },
    portal(){
      return window.sessionStorage.getItem("portal");
    }
  },
  methods: {
    submitLogin(){
        if(this.LoginReason == null) 
        {
            this.$confirm(
                `<p style="text-align:center">Please select check-in reason before you proceed.</p><br>`,
                "Warning",
                {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "error",
                dangerouslyUseHTMLString: true,
                center: true,
                }
            ).then(() => {
                
            });
        }
        else
        {
          this.$emit("showLoadingFromModal");
          var args = {
            jobSeekerId: this.currentUser.applicant_user_info.jobSeekerId,
            checkinReason: this.LoginReason
          };
          this.$store.dispatch('jobseeker/createjobseekerremotecheckin', args)
          .then((res) => {
              this.showLoginModal = false;
              this.$message.success(`Check-in reason noted.`);
              localStorage.setItem("remote-checkin", true);
              
            })
            .finally(() => {
              this.$emit("hideLoadingFromModal");
            });
        }
        
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
    // width: 300px;
    height: 60px;
    border-radius: 15px;
    border: 1px solid #40d6e5;
    margin: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    /* display: flex; */
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    /* -webkit-box-align: center; */
    -ms-flex-align: center;
    /* align-items: center; */
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding-left: 10px;
}

.radio-button {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-bottom: 10px;
}

.label {
  color: black;
    // display: block;
    position: absolute;
    font-size: 20px;
    margin-left: 20px;
    padding-top: 10px;;
}

</style>
